import { render, staticRenderFns } from "./EmploymentContractList.vue?vue&type=template&id=8e670a4c&"
import script from "./EmploymentContractList.vue?vue&type=script&lang=js&"
export * from "./EmploymentContractList.vue?vue&type=script&lang=js&"
import style0 from "./EmploymentContractList.vue?vue&type=style&index=0&id=8e670a4c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports